module.exports = {
    // 头部菜单
    header_menu: {
        logout: '退出',
        index: '首页',
        game: '游戏',
        news: '动态',
        about: '关于玩蟹',
        JoinUs: '加入我们',
        Join: '加入我们',
    },
    // 标题
    title: {
        gname: '游戏',
        gmore: '查看所有游戏',
        nname: '动态',
        nmore: '查看所有动态'
    },
    //按钮
    btn: {
        explore: '立即探索',
        website: '进入官网'
    }
}


// WEBPACK FOOTER //
// ./src/language/zh.js